<template>
  <Layer
    mask-direction=""
    class="slideMiddle_in"
    :visible="visible"
    :layerName="layerName"
  >
    <div class="dlrLayer-middle dlrLayer-middle-popup">
      <div
        class="dlrMiddlePopup"
        :class="{ 'dlrMiddlePopup-hasIcon': showDlrMiddlePopupIcon }"
      >
        <span
          class="dlrMiddlePopup-close"
          v-if="showCloseIcon"
          @click.stop="onCancelHandle"
          >关闭</span
        >
        <div class="dlrMiddlePopup-portrait" v-if="isShowPopupIconUrl">
          <img :src="photoUrl" alt="photoUrl" />
        </div>
        <div class="dlrMiddlePopup-title">
          {{ title }}
        </div>
        <div class="dlrMiddlePopup-text">
          {{ content }}
        </div>
        <div class="dlrMiddlePopup-text">
          <slot></slot>
        </div>
        <div class="dlrMiddlePopup-buttons">
          <span
            v-if="showCancel"
            class="dlrMiddlePopup-button dlrMiddlePopup-button-bold"
            v-stat:click="{ action: pvTrackCancelClick, extend: cancelExtend }"
            @click.stop="onCancelHandle"
            >{{ cancelText }}</span
          >
          <span
            class="dlrMiddlePopup-button"
            v-stat:click="{ action: pvTrackClick, extend: okExtend }"
            v-stat:show="{ action: pvTrackShow }"
            @click.stop="onOkHandle"
            >{{ okText }}</span
          >
        </div>
        <div class="dlrMiddlePopup-tip" v-if="tip">
          {{ tip }}
        </div>
      </div>
    </div>
    <div class="dlrLayer-mask" @click.stop="onCancelHandle"></div>
  </Layer>
</template>
<script>
import Layer from './Layer.vue';
import * as layerNames from '../services/layerName';
import defaultPhotoUrl from '@/assets/img/confirm-portrait-dafault.png';
export default {
  name: 'Confirm',
  data () {
    return {
      visible: true,
    };
  },
  components: {
    Layer
  },
  props: {
    layerName: {
      type: String,
      default: layerNames.CONFIRM
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    // 图片url是否显示
    isShowPopupIconUrl: {
      type: Boolean,
      default: false
    },
    // 图片url
    popupIconUrl: {
      type: String,
      default: defaultPhotoUrl
    },
    showDlrMiddlePopupIcon: {
      type: Boolean,
      default: false
    },
    showCloseIcon: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    },
    onOk: {
      type: Function,
      default: null
    },
    onCancel: {
      type: Function,
      default: null
    },
    pvTrackClick: {
      type: String,
      default: ''
    },
    pvTrackShow: {
      type: String,
      default: ''
    },
    pvTrackCancelClick: {
      type: String,
      default: ''
    },
    okExtend: {
      type: Object,
      default: null
    },
    cancelExtend: {
      type: Object,
      default: null
    },
    tip: {
      type: String,
      default:''
    }
  },
  computed: {
    photoUrl () {
      if (this.popupIconUrl === '' || !this.popupIconUrl) {
        return defaultPhotoUrl;
      } else {
        return this.popupIconUrl;
      }
    }
  },
  methods: {
    onCloseHandle () {
      this.visible = false;
    },
    onCancelHandle () {
      this.onCloseHandle();
      if (this.onCancel) {
        this.onCancel();
      }
    },
    onOkHandle () {
      this.onCloseHandle();
      if (this.onOk) {
        this.onOk();
      }
    },
  }
};
</script>
<style lang="scss">
.dlrMiddlePopup {
  position: relative;
  width: ptrd(560);
  background: #fff;
  border-radius: ptrd(16);
  padding: ptrd(40);
  box-sizing: border-box;
  &-hasIcon {
    padding-top: ptrd(54px);
    &::before {
      position: absolute;
      content: "";
      width: ptrd(240px);
      height: ptrd(190px);
      background: url($img + "kl01.png") no-repeat center center;
      background-size: 100%;
      left: 50%;
      transform: translateX(-50%);
      top: ptrd(-110px);
    }
  }
  &-portrait {
    width: ptrd(104px);
    height: ptrd(104px);
    border: 1px solid #fff;
    box-sizing: border-box;
    border-radius: 100%;
    overflow: hidden;
    line-height: ptrd(104px);
    font-size: 0;
    margin: ptrd(-90px) auto 0;
    img {
      display: inline-block;
      vertical-align: middle;
      width: 100%;
      height: auto;
    }
  }
  &-close {
    display: block;
    position: absolute;
    top: ptrd(32);
    right: ptrd(32);
    width: ptrd(24);
    height: ptrd(24);
    font-size: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAABbElEQVRIDbWWu07DMBSGz3GegRFeoggBU2HpCK8AQnSrEIi5YUbt0AFUict7MLEhBiSegQdgYa/x7+ZUSeP4kkCk1ml8/H2+nNjl84v8mBZ0zcQP89n4mf7gGo5uTjTpM1J0m/V2+o+k9T6RPtrePfj5eH996+IYjvJLrfWdYWwS8ZZCzwVoKiYIkN+pZQGfSDuwM9PjT/TcPBwUFYM2I6nBma/ms/w+AxTT0kXSAJ+CbQVdJD54RdBGEoLXBCmSGLhTECOJhYPF+Gq6XCDEIp2lDS+zxS6oPCuXXgEC1yWVxgE4YldZVG5YvneksK0O9VwYSm7+qwyOwDNFUW+8V7AOx7SYz4sZbfS20ihwwc3eMnWsiXckTkETXNYpRVIThOCpkoogFp4iWQlS4bESK2gLj5GwPaD14kmCY99QiS+X9Y6qU2VP/yKqCxwIpDEYIgU76+31v3H6M6sxzlCpbFsuU/jwy+zTG/jb8guhO1HgAvG/JAAAAABJRU5ErkJggg==);
    background-size: 100% 100%;
  }

  &-title {
    font-size: ptrd(36);
    color: #111e36;
    text-align: center;
    line-height: ptrd(50);
    padding-top: ptrd(16);
    font-weight: bold;
  }

  &-text {
    font-size: ptrd(32);
    color: #666d7f;
    text-align: center;
    line-height: ptrd(44);
    margin-top: ptrd(8);
    a{
      color:#0055FF;
    }
  }

  &-buttons {
    display: flex;
    padding-top: ptrd(28);
  }
  &-tip {
    margin-top: ptrd(32);
    color: #666d7f;
    text-align: center;
    font-size: ptrd(16);
  }

  &-button {
    position: relative;
    flex: 1;
    display: block;
    line-height: ptrd(80);
    margin-left: ptrd(20);
    @include gradient-horizontal(#4c88ff, #206cfe);
    border-radius: ptrd(8);
    text-align: center;
    color: #fff;
    cursor: pointer;
    font-weight: bold;
    font-size: ptrd(28);
    &:first-child {
      margin-left: 0;
    }

    &-bold {
      background: #fff;
      color: #0055ff;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border: 1px solid rgba(60, 120, 255, 0.2);
        border-radius: ptrd(8);
        pointer-events: none;
      }
    }

    &-disabled {
      background: #f1f3f6;
      color: #c5cad4;
    }
  }
}
</style>
